import * as graphql from '@attain-apps/fe/web/main/lib/graphql'
import gql from 'graphql-tag'

const DOC = gql`
  mutation RemoveAccessAssignment(
    $tenantId: ID!
    $zoneId: ID!
    $appId: ID!
    $scenarioId: ID!
    $id: ID!
  ) {
    tenant(id: $tenantId) {
      zone(id: $zoneId) {
        app(id: $appId) {
          scenario(id: $scenarioId) {
            extra {
              space {
                removeAccessAssignment(id: $id)
              }
            }
          }
        }
      }
    }
  }
`

export const executor = graphql.createExecutor<
  graphql.schema.RemoveAccessAssignmentMutation,
  undefined,
  graphql.schema.RemoveAccessAssignmentMutationVariables
>({
  query: DOC,
  transformer: graphql.transformers.OUT.always(undefined),
})
